import { render, staticRenderFns } from "./DesignFormButtonAuth.vue?vue&type=template&id=041d1298&scoped=true&"
import script from "./DesignFormButtonAuth.vue?vue&type=script&lang=js&"
export * from "./DesignFormButtonAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d1298",
  null
  
)

export default component.exports